import React from "react";
import { Button } from "primereact/button";
import "./SideNavigation.css";
import UserAccountButton from "./userAccount/UserAccount";
import useUserRole from "../../../utils/auth/useUserRole";

const SideNavigation = ({
    selectedSection,
    onSectionChange,
    toggleSidebar,
    isSidebarCollapsed,
    handleHomeClick,
}) => {
    const { isAdmin } = useUserRole();
    const handleChatIconClick = () => {
        onSectionChange("chats");
    };

    const handleToggleClick = () => {
        toggleSidebar();
    };

    return (
        <div className="navigation">
            <Button
                className="navigation-button toggle-sidebar-button"
                icon={`pi ${isSidebarCollapsed ? "pi-angle-double-right" : "pi-angle-double-left"}`}
                onClick={handleToggleClick}
                tooltip="Toggle Sidebar"
                tooltipOptions={{ position: "right", className: "custom-tooltip" }}
            />
            <Button
                className={`navigation-button ${selectedSection === "home" ? "active" : ""}`}
                icon="pi pi-home"
                onClick={handleHomeClick}
                tooltip="Extensions"
                tooltipOptions={{ position: "right", className: "custom-tooltip" }}
            />
            <Button
                className={`navigation-button ${selectedSection === "chats" ? "active" : ""}`}
                icon="pi pi-comments"
                onClick={handleChatIconClick}
                tooltip="Chats"
                tooltipOptions={{ position: "right", className: "custom-tooltip" }}
            />
            <Button
                className={`navigation-button ${selectedSection === "publications" ? "active" : ""}`}
                icon="pi pi-book"
                onClick={() => onSectionChange("publications")}
                tooltip="Publications"
                tooltipOptions={{ position: "right", className: "custom-tooltip" }}
            />
            {isAdmin && (
                <Button
                    className={`navigation-button ${selectedSection === "approvals" ? "active" : ""}`}
                    icon="pi pi-check-square"
                    onClick={() => onSectionChange("approvals")}
                    tooltip="Approval Queue"
                    tooltipOptions={{ position: "right", className: "custom-tooltip" }}
                />
            )}
            {isAdmin && (
                <Button
                    className={`navigation-button ${selectedSection === "admin" ? "active" : ""}`}
                    icon="pi pi-shield"
                    onClick={() => onSectionChange("admin")}
                    tooltip="Admin Management"
                    tooltipOptions={{ position: "right", className: "custom-tooltip" }}
                />
            )}

            <div className="navigation-spacer"></div>
            <UserAccountButton />
        </div>
    );
};

export default SideNavigation;
